import { get } from "lodash-es";
import { MESApiService, getMomentTz, spParameter } from "../../../services";
import { ShiftInfo } from "../../shift-navigator";
import { ShiftData } from "../../shift-navigator-v2";

const moment = getMomentTz();

export const getShifts = async (
	params: { shiftId: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{
			name: "ShiftId",
			value: params.shiftId ?? null,
		},
	];

	const resp = await apiService.callV2(
		`[MES].[GetShiftByParameters]`,
		parameters,
		signal,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as ShiftInfo[];
		rows = rows.map((row) => {
			(row.CurrentProductionDate = moment
				.utc(row["CurrentProductionDate"])
				.toDate()),
				(row.CurrentStart = moment.utc(row["CurrentStart"]).toDate()),
				(row.CurrentEnd = moment.utc(row["CurrentEnd"]).toDate()),
				(row.PreviousProductionDate = moment
					.utc(row["PreviousProductionDate"])
					.toDate()),
				(row.PreviousStart = moment.utc(row["PreviousStart"]).toDate()),
				(row.PreviousEnd = moment.utc(row["PreviousEnd"]).toDate()),
				(row.NextProductionDate = moment
					.utc(row["NextProductionDate"])
					.toDate()),
				(row.NextStart = moment.utc(row["NextStart"]).toDate()),
				(row.NextEnd = moment.utc(row["NextEnd"]).toDate()),
				(row.LastProductionDate = moment
					.utc(row["LastProductionDate"])
					.toDate()),
				(row.LastStart = moment.utc(row["LastStart"]).toDate()),
				(row.LastEnd = moment.utc(row["LastEnd"]).toDate());
			return row;
		});

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching shifts");
	}
};

export const getShiftsByRange = async ({
	shiftId,
	assetId,
	shiftsBefore,
	shiftsAfter,
}: {
	shiftId?: number;
	assetId?: number;
	shiftsBefore?: number;
	shiftsAfter?: number;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "ShiftId", value: shiftId ?? null },
		{ name: "AssetId", value: assetId ?? null },
	];

	if (shiftsBefore !== undefined) {
		parameters.push({ name: "ShiftsBefore", value: shiftsBefore });
	}
	if (shiftsAfter !== undefined) {
		parameters.push({ name: "ShiftsAfter", value: shiftsAfter });
	}

	const resp = await apiService.callV2("[MES].[GetShiftsByRange]", parameters);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as ShiftData[];

		rows = rows.map((row: ShiftData) => ({
			...row,
			Start: moment.utc(row.Start).toDate(),
			End: moment.utc(row.End).toDate(),
		}));

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching shifts by range");
	}
};

export const getShiftsAroundCurrent = async ({
	currentShiftId,
	shiftsRange,
}: {
	currentShiftId?: number;
	shiftsRange?: number;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "CurrentShiftId", value: currentShiftId || null },
	];

	if (shiftsRange) {
		parameters.push({ name: "ShiftsRange", value: shiftsRange });
	}

	const resp = await apiService.callV2(
		"[MES].[GetShiftsAroundCurrent]",
		parameters,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as ShiftData[];

		rows = rows.map((row: ShiftData) => ({
			...row,
			Start: moment.utc(row.Start).toDate(),
			End: moment.utc(row.End).toDate(),
		}));

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching shifts");
	}
};
